// Für diese Installation gültige Mehrwertsteuersätze (als String-Keys, passend zu
// rechnung.mwst_betrag_eur, z.B. "0", "7", "19").
//
// WICHTIG: Muss zum Abschnitt "Steuersaetze" in der Backend-appsettings.json dieser
// Installation passen (siehe DatenLeserWeb/appsettings.json, SteuersatzOptions in
// RechnungCustom). Das ist bewusst KEINE zur Laufzeit vom Server geladene Einstellung,
// sondern eine Build-Time-Konstante: Steuersätze ändern sich sehr selten, und jede
// Installation hat ohnehin ihre eigene Konfiguration und wird bei Bedarf einzeln neu
// gebaut/deployed (siehe Wartungs-Workflow). Bei einer Änderung: hier UND in der
// Backend-appsettings.json anpassen, dann Frontend neu bauen.
//
// Reihenfolge bestimmt die Spaltenreihenfolge in Korrektur-Tabelle und Excel-Export.
export const STEUERSAETZE = ["0", "7", "19"];